var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsmeralda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 581.343,
    x2: 556.715,
    y1: 259.902,
    y2: 141.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 650.752,
    x2: 586.166,
    y1: 227.126,
    y2: 167.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 604.021,
    x2: 595.475,
    y1: 255.053,
    y2: 148.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 593.661,
    x2: 613.032,
    y1: 205.451,
    y2: 205.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 2644.588,
    x2: 2698.909,
    y1: 755.784,
    y2: 755.784,
    gradientTransform: "rotate(180 1647.718 438.534)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -957.995,
    x2: -903.674,
    y1: 755.784,
    y2: 755.784,
    gradientTransform: "matrix(1 0 0 -1 1500.2 877.067)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 601.489,
    x2: 571.474,
    y1: 214.211,
    y2: 127.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#f9fcfb",
      stopOpacity: 0.0955
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    style: {
      stopColor: "#e8f5ef",
      stopOpacity: 0.2238
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#cce8db",
      stopOpacity: 0.3708
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#a4d7c0",
      stopOpacity: 0.5317
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    style: {
      stopColor: "#72c19d",
      stopOpacity: 0.7039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#36a673",
      stopOpacity: 0.8829
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    style: {
      stopColor: "#0a9355"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 2673.275,
    x2: 2724.543,
    y1: 755.784,
    y2: 755.784,
    gradientTransform: "rotate(180 1647.718 438.534)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 2678.377,
    x2: 2701.374,
    y1: 726.534,
    y2: 726.534,
    gradientTransform: "rotate(180 1647.718 438.534)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    style: {
      stopColor: "#2edb63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#098952"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m596.527 242.69-25.634-80.849h-28.687z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m622.16 161.841-25.633 80.849-25.634-80.849z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m596.527 80.859 25.633 80.849h28.688z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m570.893 161.708 25.634-80.849 25.633 80.849z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 568.133,
    cy: 149.816,
    r: 46.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    style: {
      stopColor: "#f9f9fc",
      stopOpacity: 0.8954
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    style: {
      stopColor: "#e9e8f4",
      stopOpacity: 0.7548
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#cdcce6",
      stopOpacity: 0.5937
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    style: {
      stopColor: "#a7a5d3",
      stopOpacity: 0.4175
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    style: {
      stopColor: "#7672bb",
      stopOpacity: 0.2288
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    style: {
      stopColor: "#3b369e",
      stopOpacity: 0.0325
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    style: {
      stopColor: "#312b99",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m608.857 214.6-72.654-50.101-20.507 28.628z",
    clipPath: "url(#f)",
    style: {
      opacity: 0.3,
      fill: "#00a451"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m650.848 161.841-54.321 80.849 25.633-80.849z",
    style: {
      fill: "url(#g)"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m644.229 214.095-72.653-50.102-20.507 28.629z",
    clipPath: "url(#i)",
    style: {
      opacity: 0.2,
      fill: "#00a451"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.519 187.73-57.787 63.51 25.347 26.421z",
    clipPath: "url(#i)",
    style: {
      opacity: 0.2,
      fill: "#00a451"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.005 130.982-57.787 63.51 25.347 26.422z",
    clipPath: "url(#i)",
    style: {
      opacity: 0.2,
      fill: "#00a451"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.641 173.518a1.982 1.982 0 1 0-.514-3.93 1.982 1.982 0 0 0 .514 3.93m50.948 25.587a1.982 1.982 0 1 0-.514-3.93 1.982 1.982 0 0 0 .514 3.93m-31.247-29.022a.735.735 0 1 0 1.47 0 .735.735 0 0 0-1.47 0m36.073 9.46a.735.735 0 1 0 1.47 0 .735.735 0 0 0-1.47 0m-23.304-8.725a.735.735 0 1 0 1.47 0 .735.735 0 0 0-1.47 0m23.304 16.912a.735.735 0 1 0 1.47 0 .735.735 0 0 0-1.47 0m-31.224 6.693a.735.735 0 1 0 1.47 0 .735.735 0 0 0-1.47 0",
    style: {
      opacity: 0.25,
      fill: "#dc8120"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.661 202.382 19.371 4.572-5.175 1.566z",
    style: {
      fill: "url(#j)"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.089 115.028 72.654 50.102 20.507-28.628z",
    clipPath: "url(#l)",
    style: {
      opacity: 0.3,
      fill: "#00a451"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m542.206 161.708 54.321-80.849-25.634 80.849z",
    style: {
      fill: "url(#m)"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.206 161.708 54.321-80.849-25.634 80.849z",
    style: {
      fill: "url(#n)"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m548.824 109.454 72.654 50.101 20.506-28.628z",
    clipPath: "url(#p)",
    style: {
      opacity: 0.55,
      fill: "#00a451"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.534 135.819 57.787-63.51-25.347-26.421z",
    clipPath: "url(#p)",
    style: {
      opacity: 0.55,
      fill: "#00a451"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556.048 192.566 57.787-63.509-25.347-26.422z",
    clipPath: "url(#p)",
    style: {
      opacity: 0.55,
      fill: "#00a451"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M625.412 150.031a1.982 1.982 0 1 0 .514 3.93 1.982 1.982 0 0 0-.514-3.93m-50.948-25.588a1.982 1.982 0 1 0 .515 3.931 1.982 1.982 0 0 0-.515-3.931m31.247 29.023a.735.735 0 1 0-1.47 0 .735.735 0 0 0 1.47 0m-36.073-9.46a.735.735 0 1 0-1.47 0 .735.735 0 0 0 1.47 0m23.304 8.725a.735.735 0 1 0-1.47 0 .735.735 0 0 0 1.47 0m-23.304-16.912a.735.735 0 1 0-1.47 0 .735.735 0 0 0 1.47 0m31.224-6.693a.735.735 0 1 0-1.47 0 .735.735 0 0 0 1.47 0",
    style: {
      opacity: 0.25,
      fill: "#dc8120"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m617.058 156.508-22.997-5.719 5.669-6.231z",
    style: {
      fill: "url(#q)"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.724 161.708h21.169l23.168-73.073z",
    style: {
      opacity: 0.55,
      fill: "#00a451"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.893 158.555 14.585 52.442-15.585-49.289h-28.687l27.432-1.98 24.423-71.093z",
    style: {
      fill: "url(#r)"
    },
    transform: "translate(-132.999 -18.346)scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsmeralda);
export default __webpack_public_path__ + "static/media/esmeralda.0f0dda8730d145b4d55e2501bd8cbbe6.svg";
export { ForwardRef as ReactComponent };